import { FadeUp, ButtonPrimary } from "./Reveal";
import { WorkAreaMap } from "./WorkAreaMap";
import { useContent } from "../context/ContentContext";

export const WorkAreaSection = () => {
  const { workArea } = useContent();
  return (
  <section data-testid="work-area-section" className="bg-white">
    <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-12 sm:px-6 sm:py-16 lg:grid-cols-5">
      <div className="lg:col-span-2">
        <FadeUp>
          <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#8E8D8A]">
            Werkgebied
          </p>
          <h2 className="mt-3 font-display text-2xl font-bold uppercase tracking-wide text-[#111111] sm:text-3xl">
            Kom ik bij jou langs?
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-[#555555]">
            Ik werk vanuit Opmeer in heel West-Friesland en de kop van
            Noord-Holland, grofweg binnen {workArea.radiusKm} kilometer. Woon je
            net buiten dit gebied? Vraag het gerust, vaak is er meer mogelijk dan
            je denkt.
          </p>
        </FadeUp>
        <FadeUp delay={0.05}>
          <ul data-testid="work-area-places" className="mt-6 flex flex-wrap gap-2">
            {workArea.places.map((p) => (
              <li
                key={p.name}
                className={`px-3 py-1.5 font-display text-xs font-bold uppercase tracking-wide ${
                  p.home ? "bg-cream text-[#111111]" : "bg-[#EFEDE8] text-[#333333]"
                }`}
              >
                {p.name}
              </li>
            ))}
          </ul>
        </FadeUp>
        <FadeUp delay={0.1} className="mt-8">
          <ButtonPrimary to="/contact" testid="work-area-cta">
            Vraag een offerte aan
          </ButtonPrimary>
        </FadeUp>
      </div>
      <FadeUp delay={0.1} className="lg:col-span-3">
        <WorkAreaMap />
      </FadeUp>
    </div>
  </section>
);
};
